import React, { Component } from 'react'
import {AddToCart} from '../api/cart'

class PeiripheralLicense extends Component {

    constructor(props) {
        super(props);

        this.AddToCart = this.AddToCart.bind(this);
    }

    async AddToCart(e, data){

        try{
            e.preventDefault();
            let added = await AddToCart(data);
            window.location.replace(added.url);

        }catch(ex){
            console.log(ex);
        }
    }

    render() {
        return (
            <div>

                {(t => {
                    if (t.props.license.ProductType == 35 || t.props.license.ProductType == 33|| t.props.license.ProductType == 280 ) {
                        return (
                            <div className="row mydistro-wrapper">
                                <div className="col-md-12">
                                <h5>{this.props.license.ProductName}</h5>
                                    <strong>Distribution Key (Please copy this key and use it in your app):</strong>

                                    {t.props.license.LicenseKeys ?
                                        <form className="gc-form">
                                            <textarea className="mydistro-mydistkey" readOnly defaultValue={t.props.license.LicenseKeys[0]} />
                                        </form>
                                        : <p>No distribution key has been generated for this license.</p>
                                    }
                                </div>
                            </div>
                        )
                    } else {
                        return (

                            <div className="row mydistro-wrapper">
                                <div className="col-md-8 mydistro-meta">
                                    <h5>{this.props.license.ProductName}</h5>
                                    {this.props.license.AddonDomains !=0 && <p>Includes <b>{this.props.license.AddonDomains}</b> Extra/Commercial Hostnames</p>}
                                    <p><strong>Hostnames Registered:</strong> {t.props.license.DomainsRegistered}/{t.props.license.DomainsAllowed == -1 ? "Unlimited" : t.props.license.DomainsAllowed}</p>

                                    {((t) => {
                                        if(t.props.license.Domains.length > 0){
                                            let domains = t.props.license.Domains.map(domain => {
                                                return <li key={domain.Id}>{domain.Name}</li>
                                            })
                                            return (<div class="mydistro-domains"><div class="mydistro-scrolling-list"><ul>{domains}</ul></div></div>)
                                        }

                                    })(this)}
                                </div>
                                <div className="col-md-4 mydistro-actions">
                                    <p>
                                        <strong>Actions:</strong>
                                    </p>
                                    <p><a rel="nofollow" href={"/my-account/create-distribution-key/" + t.props.license.encKey}>Create Distribution Key</a></p>
                                    {this.props.license.SAASProductCode==`W21B` && <p><a rel="nofollow" href={`#`} onClick={e=>this.AddToCart(e, {"sku":62767, "forSubscription":t.props.license.LicenseID}) }>Purchase Additional Hostnames</a></p>}
                                </div>
                            </div>
                        )
                    }
                })(this)}
            </div>
        )
    }
}

export default PeiripheralLicense